<ng-container *ngIf="state$ | async as state">
  <div class="split-preview" *ngIf="state.visible">
    <div class="split-preview__header" *ngIf="state.tabs?.length">
      <div class="split-preview__tabs">
        <button
          class="split-preview__tab"
          *ngFor="let tab of state.tabs; trackBy: trackTab"
          [class.split-preview__tab--active]="tab.id === state.activeTabId"
          (click)="setActive(tab.id)"
        >
          <mat-icon class="mr-1" *ngIf="tab.loading">hourglass_empty</mat-icon>
          <mat-icon class="mr-1" *ngIf="!tab.loading">description</mat-icon>
          <span class="split-preview__tab-title">
            {{ tab.file?.nome || "Documento" }}
          </span>
          <button
            mat-icon-button
            class="split-preview__tab-close"
            (click)="closeTab(tab.id); $event.stopPropagation()"
            aria-label="Chiudi tab"
          >
            <mat-icon>close</mat-icon>
          </button>
        </button>
      </div>
      <button
        mat-icon-button
        class="split-preview__close-all"
        (click)="close()"
        aria-label="Chiudi tutte le preview"
        matTooltip="Chiudi tutte le preview"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="split-preview__body">
      <ng-container *ngIf="getActiveTab(state) as active">
        <mat-spinner *ngIf="active.loading"></mat-spinner>
        <iframe
          *ngIf="!active.loading && active.safeUrl"
          class="split-preview__iframe"
          [src]="active.safeUrl"
          title="Anteprima PDF"
          frameborder="0"
        ></iframe>
      </ng-container>
    </div>
  </div>
</ng-container>
